import React, { Fragment, useEffect } from 'react';
import { Sidesheet, Button, EmptyState } from '@innovaccer/design-system';
import _ from 'lodash';

import standardETLNotification from '../../../components/AlertService';
import ProgressLoader from '../../../components/Utility/progress';

import ConfigUpload from './configUpload';
import ExecutionConfig from './viewConfig';
import ShowError from './showErrorMsg';

import { getGlobalVariable } from '../../../utils/utils';
import pageNotLoaded from '../../../assets/images/pageNotLoaded.png';
import api from '../../../api';

function EtlConfig(props) {
  const [fetchState, setFetchState] = React.useState({ loading: true, error: false });
  const [saveState, setSaveState] = React.useState({ loading: false, error: false, message: '' });
  const [isEdited, setIsEdited] = React.useState(false);
  const [executionConfig, setExecutionConfig] = React.useState({});

  useEffect(() => {
    const { workflowID, workspaceID } = getGlobalVariable();
    fetchExecutionSettings({ workspaceID, workflowID });
  }, []);

  const fetchExecutionSettings = (payload) => {
    api
      .getExecutionSettingsData(payload)
      .then((data) => {
        setFetchState({ loading: false, error: false });
        data && setExecutionConfig(data.saved_config);
      })
      .catch(() => {
        setFetchState({ loading: false, error: true });
      });
  };

  const saveExecutionSettings = () => {
    setSaveState({ loading: true, error: false, message: '' });
    const { workflowID, workspaceID } = getGlobalVariable();
    const params = { workflowID, workspaceID };
    api
      .saveExecutionSettings(params, {
        config: executionConfig,
        id: getGlobalVariable('pipelineId'),
        user_id: window.skeletonPwa.container.auth.userData.id
      })
      .then(() => {
        standardETLNotification({
          title: 'Execution settings updated successfully.',
          appearance: 'info'
        });
        setSaveState({ loading: false, error: false });
        handleClose();
      })
      .catch((err) => {
        setSaveState({
          loading: false,
          error: true,
          message: err.message ? err.message.message : err.message.error.message
        });
      });
  };

  const handleConfigUpload = (data) => {
    setExecutionConfig(data);
    setIsEdited(!_.isEmpty(data));
    setSaveState({ loading: false, error: false });
  };

  const headerOptions = {
    heading: 'Execution settings configuration'
  };

  const options = {
    onClose: () => handleClose(),
    open: true,
    headerOptions,
    stickFooter: true,
    dimension: 'large',
    footer: (
      <Fragment>
        <Button
          appearance="primary"
          className="mr-4"
          loading={saveState.loading}
          disabled={!isEdited}
          onClick={saveExecutionSettings}
        >
          Save
        </Button>
        <Button appearance="basic" onClick={() => handleClose()}>
          Cancel
        </Button>
      </Fragment>
    )
  };

  const handleClose = getGlobalVariable('closeConfiguration');
  return (
    <Sidesheet {...options}>
      <div className="h-100">
        {fetchState.loading && !fetchState.error && <ProgressLoader />}
        {!fetchState.loading && !fetchState.error && (
          <Fragment>
            <ConfigUpload
              executionConfig={executionConfig}
              handleConfigUpload={handleConfigUpload}
              handleClose={handleClose}
            />
            {!_.isEmpty(executionConfig) && saveState.error && <ShowError message={saveState.message} />}
            {!_.isEmpty(executionConfig) && <ExecutionConfig data={executionConfig} />}
          </Fragment>
        )}
        {!fetchState.loading && fetchState.error && (
          <EmptyState size="large" title="Failed to load the data" imageSrc={pageNotLoaded} />
        )}
      </div>
    </Sidesheet>
  );
}

export default EtlConfig;
